import * as React from 'react';

import styled, { css } from 'styled-components';

import DeleteIcon from '@components/basics/icons/delete';

export interface BoxProps {
  className?: string;
  style?: React.CSSProperties;
  children?: any;
  noRadius?: boolean;
  collapse?: boolean;
  disabled?: boolean;
  hasClose?: boolean;
  onClose?: (ev: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
  small?: boolean;
  smallVertical?: boolean;
  bgColor?: string;
  onClick?: () => void;
  noBorder?: boolean;
  noBorderTop?: boolean;
  noBorderBottom?: boolean;
  noBorderLeft?: boolean;
  noBorderRight?: boolean;
  onMouseEnter?: React.MouseEventHandler<HTMLDivElement>;
  onMouseLeave?: React.MouseEventHandler<HTMLDivElement>;
}

export const Box: React.FC<BoxProps> = (props) => (
  <div
    className={props.className}
    onClick={() => (props.onClick ? props.onClick() : null)}
    style={props.style}
    onMouseEnter={props.onMouseEnter}
    onMouseLeave={props.onMouseLeave}
  >
    {props.children}
    {props.hasClose ? (
      <DeleteIcon className="delete-icon-box" onClick={props.onClose} />
    ) : null}
  </div>
);

export default styled(Box)`
  border-radius: 10px;
  background-color: ${({ theme }) => theme.colors.box};
  padding: 20px;
  position: relative;
  ${(props) =>
    props.noBorder
      ? css`
          border-radius: 0px;
        `
      : null};
  ${(props) =>
    props.noBorderTop
      ? css`
          border-top-left-radius: 0px;
          border-top-right-radius: 0px;
        `
      : null};
  ${(props) =>
    props.noBorderBottom
      ? css`
          border-bottom-left-radius: 0px;
          border-bottom-right-radius: 0px;
        `
      : null};
  ${(props) =>
    props.noBorderLeft
      ? css`
          border-top-left-radius: 0px;
          border-bottom-left-radius: 0px;
        `
      : null};
  ${(props) =>
    props.noBorderRight
      ? css`
          border-bottom-right-radius: 0px;
          border-top-right-radius: 0px;
        `
      : null};

  ${(props) =>
    props.bgColor
      ? css`
          background-color: ${props.bgColor};
        `
      : null};
  ${(props) =>
    props.disabled
      ? css`
          background-color: ${({ theme }) => theme.colors.tertiary};
        `
      : null};

  @media ${({ theme }) => theme.device.laptopS} {
    padding: 20px;
  }

  @media ${({ theme }) => theme.device.laptopL} {
    padding: 30px;
  }

  ${(props) =>
    props.collapse
      ? css`
          padding: 0;

          @media ${({ theme }) => theme.device.mobileL} {
            padding: 0;
          }
        `
      : null}

  ${(props) =>
    props.noRadius
      ? css`
          border-radius: 0;
        `
      : null}

  ${(props) =>
    props.small && !props.collapse
      ? css`
          padding: 20px;

          @media ${({ theme }) => theme.device.tablet} {
            padding: 20px;
          }

          @media ${({ theme }) => theme.device.laptopS} {
            padding: 20px;
          }

          @media ${({ theme }) => theme.device.laptopL} {
            padding: 20px;
          }
        `
      : null}
  ${(props) =>
    props.smallVertical
      ? css`
          padding: 16px 30px;

          @media ${({ theme }) => theme.device.tablet} {
            padding: 16px 30px;
          }

          @media ${({ theme }) => theme.device.laptopS} {
            padding: 16px 30px;
          }

          @media ${({ theme }) => theme.device.laptopL} {
            padding: 16px 30px;
          }
        `
      : null}

  ${(props) =>
    props.hasClose
      ? css`
          .delete-icon-box {
            position: absolute;
            top: -12px;
            left: -12px;
            z-index: 4;

            @media ${({ theme }) => theme.device.tablet} {
              opacity: 0;
              pointer-events: none;
              transition: opacity
                ${({ theme }) =>
                  `${theme.transitions.duration} ${theme.transitions.type}`};
            }
          }

          @media ${({ theme }) => theme.device.tablet} {
            &:hover {
              .delete-icon-box {
                opacity: 1;
                pointer-events: all;
              }
            }
          }
        `
      : null}
`;
